module.exports = __webpack_public_path__ + "img/car_00038.4890af74.jpg";